export default __webpack_public_path__ + "static/media/OCTDOM2024.91849815.png";